import React from 'react';
export function Footer() {
  return <footer className="w-full bg-ink" data-id="element-72" data-mp="32wd2qgad7ltj">
      <div className="mx-auto max-w-6xl px-5 py-12 text-center" data-id="element-73" data-mp="3gezc50oadkzk">
        <p className="text-lg font-bold text-white" data-id="element-74" data-mp="3ggk88uq91bzj">🚶 Camina y Transforma</p>
        <p className="mx-auto mt-2 max-w-md text-sm text-white/60" data-id="element-75" data-mp="32p5lcct80qn7">
          Programa online de caminata para bajar de peso de forma natural y sostenible.
        </p>
        <nav className="mt-6 flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-sm text-white/70" data-id="element-76" data-mp="3ueiltxwqx4dz">
          <a href="#" className="transition-colors hover:text-white" data-id="element-77" data-mp="38z70lzg0p09">Términos y condiciones</a>
          <a href="#" className="transition-colors hover:text-white" data-id="element-78" data-mp="3lf56iolxxllc">Política de privacidad</a>
          <a href="#" className="transition-colors hover:text-white" data-id="element-79" data-mp="3qcnkiteter07">Contacto / WhatsApp</a>
        </nav>
        <p className="mt-8 text-xs text-white/40" data-id="element-80" data-mp="29yxbr9cr3ek8">
          © 2025 Camina y Transforma · Todos los derechos reservados
        </p>
      </div>
    </footer>;
}